import { render } from "./SurveyBuilder.vue?vue&type=template&id=09ab0140&scoped=true"
import script from "./SurveyBuilder.vue?vue&type=script&lang=js"
export * from "./SurveyBuilder.vue?vue&type=script&lang=js"

import "./SurveyBuilder.vue?vue&type=style&index=0&id=09ab0140&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09ab0140"]])

export default __exports__